import { vesselDetailsFormInit } from "../models/tq1-vessel-details.models";
import type { Tq1VesselDetailsM } from "../models/tq1-vessel-details.models";
import { promoteOrInsertFirstEmailContact } from "./promote-or-insert-first-email-contact.utils";

export function prepareVesselDetailsForEditing(
  value: Partial<Tq1VesselDetailsM> | null,
  vesselName?: string,
  imoNumber?: string,
): Tq1VesselDetailsM {
  const base = vesselDetailsFormInit(vesselName, imoNumber);
  const form = value && typeof value === "object" ? value : {};
  return {
    ...base,
    ...form,
    contactDetails: promoteOrInsertFirstEmailContact(Array.isArray(form.contactDetails) ? form.contactDetails : []),
    wlthc: {
      ballast: { ...base.wlthc.ballast, ...form.wlthc?.ballast },
      fullBallast: { ...base.wlthc.fullBallast, ...form.wlthc?.fullBallast },
      fullyLaden: { ...base.wlthc.fullyLaden, ...form.wlthc?.fullyLaden },
    },
  };
}
